<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="电话">
        <el-input v-model="query.phone" clearable placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="query.enroll_role" placeholder="角色" clearable>
          <el-option
            v-for="(v, i) in enrollUserTypes"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="擅长人群">
        <el-select
          v-model="query.specialty_tags"
          placeholder="擅长人群"
          clearable
        >
          <el-option
            v-for="(v, i) in userPersonTypes"
            :key="i"
            :label="v.name"
            :value="v.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addNew">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #avatar="{ row }">
        <img :src="row.avatar" alt="" class="avatar" />
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 1"
            >待审核</el-tag
          >
          <el-tag type="success" size="small" v-if="row.status === 2"
            >通过</el-tag
          >
          <el-tag type="danger" size="small" v-if="row.status === 3"
            >审核拒绝</el-tag
          >
          <el-tag type="danger" size="small" v-if="row.status === 4"
            >冻结</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <!-- <el-button
            v-if="row.status == 1"
            type="success"
            size="small"
            @click="updateStatus(row, 2)"
            >通过</el-button
          >

          <el-button
            v-if="row.status == 2"
            type="warning"
            size="small"
            @click="updateStatus(row, 4)"
            >冻结</el-button
          > -->
          <el-button type="success" size="small" @click="details(row)"
            >详情</el-button
          >
        </div>
      </template>
    </auto-table>
  </div>
</template>

<script>
import { enrollUserTypes, userPersonTypes } from "../dict";
export default {
  data() {
    return {
      enrollUserTypes,
      userPersonTypes,

      DataList: [],
      Option: [
        { name: "头像", value: "avatar", type: "custom" },
        { name: "名称", value: "nick_name" },
        { name: "身份", value: "enroll_role" },

        { name: "招生人群", value: "specialty_tags" },

        { name: "区域", value: "working_areas" },

        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
      query: {},
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    details(row) {
      this.$router.push({ name: "enroll_d", query: { id: row.id } });
    },
    addNew() {
      this.$refs.add.open();
    },

    //获取列表
    getList(v) {
      let page = v || 1;
      let data = { currentPage: page, pageSize: 10 };
      for (let k in this.query) {
        if (this.query[k]) {
          data[k] = this.query[k];
        }
      }
      this.$axios({
        url: "/user/enrollUser/getUserListManager",
        params: data,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>